const SlaAndPriority = {

    // FIELDS
    "sla_and_priority": "SLA and Priority",
    "name": "Name",
    "description": "Description",
    "sla": "SLA",
    "type": "Type",
    "priority_sla": "Priority SLA (Hours)",
    "priority": "Priority",
    "status": "Status",
    "search": "Search",

    // PAGE HEADER
    "list_title": "SLA and Priority",
    "filter_title": "SLA and Priority Filter",

    // TABLE HEADER
    "table_name": "Name",
    "table_sla": "SLA",
    "table_type": "Type",
    "table_priority": "Priority",
    "table_description": "Description",

    // ERROR
    "error_name": "Enter Name",
    "error_description": "Enter Description",
    "error_sla": "Enter SLA",
    "error_type": "Select Type",
    "error_priority": "Enter Priority",
    "error_status": "Select Status",

}

export default SlaAndPriority;

